import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Tag } from 'antd';
import { Enumify } from "enumify-ts";
class TxnStatus extends Enumify() {
    description;
    colour;
    static FAILED = new TxnStatus("FAILED", "volcano");
    static SUCCESS = new TxnStatus("SUCCESS", "green");
    static PENDING = new TxnStatus("PENDING", "blue");
    static _ = TxnStatus._closeEnum();
    constructor(description, colour) {
        super();
        this.description = description;
        this.colour = colour;
    }
    renderTag() {
        return _jsx(Tag, { color: this.colour, children: this.description });
    }
    static filtersArray() {
        return TxnStatus.values.map(t => {
            return { text: t.description, value: t.key };
        });
    }
}
export default TxnStatus;
